export enum ManageUserAction {
    Update = 1,
    Activate = 2,
    Deactivate = 3
}
